export const kindColorMap = {
    Component: "#4CAF50", // Green
    Resource: "#FF9800",  // Orange
    API: "#2196F3",       // Blue
    Default: "#808080",
};

export const typeColorMap = {
    Component: {
        Service: '#4CAF50', // Green
        Library: '#8BC34A', // Light Green
    },
    Resource: {
        Database: '#FF9800',   // Orange
        Bucket: '#FF5722',     // Dark Orange
    },
    API: {
        REST: '#2196F3',       // Blue
        GraphQL: '#03A9F4',    // Light Blue
    },
};
